<template>
	<div class="info-moment-box">
		<chat-moment :friend = "friend" key="ChatInfoChatMoment"></chat-moment>
	</div>
</template>

<script>
	import ChatMoment from '../../../components/ChatMoment.vue'
	export default {
		name:'ChatInfoMoment',
		data(){
			return {
				friend: {}
			}
		},
		components:{
			ChatMoment
		},
		methods:{
			
		},
		computed:{
			fans(){
				return this.$store.state.chatFans
			}
		},
		watch:{
			fans(nVal){
				this.friend = nVal
			}
		},
		created() {
			this.friend = this.fans
		},
	}
</script>

<style>
	.info-moment-box{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
</style>
